import React from 'react';

// import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../../lib/utils';

import { useTheme } from '../../../contexts/ThemeContext';
import DefaultComponent from './DefaultFooter';
import * as Components from './index';

const propTypes = {};

const defaultProps = {};

function Footer({ ...props }) {
    const { name, variant = null } = useTheme();
    const Component =
        (variant || []).reduce(
            (acc, v) => acc || getComponentFromName(Components, v, null),
            null,
        ) ||
        getComponentFromName(Components, name, DefaultComponent) ||
        null;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return Component !== null ? <Component {...props} /> : null;
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
